export const DEFAULT_VALUES = [
  { id: "default-kindness", text: "Kindness", isDefault: true },
  { id: "default-courage", text: "Courage", isDefault: true },
  { id: "default-gratitude", text: "Gratitude", isDefault: true },
  { id: "default-connection", text: "Connection", isDefault: true },
  { id: "default-growth", text: "Growth", isDefault: true },
];

export const MAX_CUSTOM_VALUES = 5;
export const VALUE_CHAR_LIMIT = 30;
